import { OrderItem, OrderTypeEnum } from '@libs/api-reference';

function getOrderPrice(order: OrderItem) {
  if (order.orderType === OrderTypeEnum.Conditional) {
    return order.upperThreshold || order.lowerThreshold || 0;
  } else {
    return order.price;
  }
}

export { getOrderPrice };
